'use client';

import {
  motion,
  useInView,
  type UseInViewOptions,
  useReducedMotion,
  type Variants,
} from 'framer-motion';
import type { ReactNode } from 'react';
import { useRef } from 'react';

import { fadeInUp } from './animations';

interface ScrollRevealProps {
  children: ReactNode;
  className?: string;
  variants?: Variants;
  margin?: UseInViewOptions['margin'];
  once?: boolean;
  id?: string;
}

export const ScrollReveal = ({
  children,
  className,
  variants = fadeInUp,
  margin = '-80px',
  once = true,
  id,
}: ScrollRevealProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, margin });
  const shouldReduceMotion = useReducedMotion();

  // prefers-reduced-motion 지원
  if (shouldReduceMotion) {
    return (
      <div id={id} className={className}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      id={id}
      variants={variants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      className={className}
    >
      {children}
    </motion.div>
  );
};
